<div style="min-height: 100vh;">
    <p-toast position="top-right"/>
    <app-header></app-header>
    <div class="my-6 p-4">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>